module.exports = {
    resizeGridItem: function(item) {
        grid = this.gridContainer;
        rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = "span " + rowSpan;
    },

    resizeAllGridItems: function() {
        allItems = this.gridContainer.children;
        for (x = 0; x < allItems.length; x++) {
            this.resizeGridItem(allItems[x]);
        }
    },

    resizeInstance: function(instance) {
        item = instance.elements[0];
        this.resizeGridItem(item);
    },

    setup: function(gridContainer) {
        this.gridContainer = gridContainer;
        gridContainer.classList.add('masonry');
        this.resizeAllGridItems();
        window.addEventListener("resize", function (e) {
            this.resizeAllGridItems()
        }.bind(this));
        allItems = gridContainer.children;
        for (x = 0; x < allItems.length; x++) {
          var imgLoad = require('imagesloaded')(allItems[x]);
          imgLoad.on('always', function(elem) {
              this.resizeInstance(elem);
          }.bind(this));
        }
    },
}